
import { Vue, Component, Prop } from 'vue-property-decorator'
import CustomWrapper from '@/components/CustomWrapper.vue'

@Component({
  name: 'c-section-title',
  components: { CustomWrapper }
})
export default class CSectionTitle extends Vue {

  @Prop({ default: 'h2'}) tag!: string

}
